const LEGEND_ROWS = [ 1, 2, 3, 4 ] as const;
const OPTION_ROWS = [ 1, 2, 3 ] as const;
const TIME_RANGE_ROWS = [ 1, 2, 3, 4, 5, 6 ] as const;
const ENGAGEMENT_ROWS = [ 1, 2, 3 ] as const;

function SkeletonBlock( { className }: { className: string } ) {
    return <div className={`skeleton rounded ${className}`} />;
}

export function NormalEventSkeleton() {
    return (
        <div
            className="event-detail-scrollable flex h-full flex-1 flex-col"
            role="status"
            aria-label="Loading event"
            aria-busy="true"
            data-event-skeleton="normal"
        >
            <div>
                <div className="flex w-full items-center">
                    <SkeletonBlock className="mt-4 h-5 w-28" />
                    <div className="ml-auto pt-4">
                        <SkeletonBlock className="size-4 rounded-full" />
                    </div>
                </div>

                <div className="flex items-center gap-3 overflow-hidden pb-4 pt-3">
                    <SkeletonBlock className="size-12 shrink-0 rounded-lg" />
                    <div className="min-w-0 flex-1 space-y-2">
                        <SkeletonBlock className="h-6 w-full" />
                        <SkeletonBlock className="h-6 w-[78%]" />
                    </div>
                </div>

                <div className="mb-3">
                    <div className="flex flex-wrap gap-x-4 gap-y-3">
                        {LEGEND_ROWS.map( row => (
                            <div key={row} className="flex min-w-0 items-center gap-2">
                                <SkeletonBlock className="size-2 shrink-0 rounded-full" />
                                <SkeletonBlock className="h-[15px] w-[120px]" />
                                <SkeletonBlock className="h-[15px] w-10 shrink-0" />
                            </div>
                        ) )}
                    </div>
                </div>

                <div className="mb-3 w-full">
                    <div className="relative overflow-hidden rounded-xl bg-surface-card px-2 pb-1 pt-2">
                        <SkeletonBlock className="h-[200px] w-full rounded-lg" />
                        <div className="flex h-9 items-center justify-center border-t border-stroke px-1">
                            <div className="flex flex-wrap items-center justify-center gap-1 sm:gap-1.5">
                                {TIME_RANGE_ROWS.map( row => (
                                    <SkeletonBlock key={row} className="h-6 w-9 rounded-full" />
                                ) )}
                            </div>
                        </div>
                    </div>
                </div>

                <div className="mb-3">
                    {OPTION_ROWS.map( row => (
                        <div key={row} className="mb-3 rounded-xl border border-stroke bg-surface-card last:mb-0">
                            <div className="flex flex-col gap-3 p-3">
                                <div className="flex h-11 w-full items-center gap-2">
                                    <div className="flex min-w-0 flex-1 items-center gap-2">
                                        <SkeletonBlock className="size-11 shrink-0 rounded-lg" />
                                        <div className="flex min-w-0 flex-1 flex-col justify-center gap-1">
                                            <SkeletonBlock className="h-5 w-full" />
                                            <SkeletonBlock className="h-5 w-[62%]" />
                                        </div>
                                    </div>
                                    <SkeletonBlock className="h-5 w-12 shrink-0" />
                                </div>
                                <div className="flex w-full gap-2">
                                    <SkeletonBlock className="h-10 min-w-0 flex-1 rounded-lg" />
                                    <SkeletonBlock className="h-10 min-w-0 flex-1 rounded-lg" />
                                </div>
                            </div>
                        </div>
                    ) )}
                </div>

                <div className="mb-3 rounded-xl border border-stroke bg-surface-card p-3">
                    <div className="flex h-6 w-full items-center justify-between">
                        <SkeletonBlock className="h-5 w-16" />
                        <SkeletonBlock className="size-6 rounded-full" />
                    </div>
                </div>

                <div className="mt-3 h-12 rounded-xl border border-stroke bg-surface-card p-3">
                    <div className="flex w-full items-center justify-between gap-2">
                        <SkeletonBlock className="h-5 w-14" />
                        <SkeletonBlock className="size-6 rounded-full" />
                    </div>
                </div>

                <div className="mb-3 mt-3 flex flex-col gap-3 rounded-xl border border-stroke bg-surface-card p-3">
                    <div className="flex h-8 items-center gap-6">
                        <SkeletonBlock className="h-5 w-16" />
                        <SkeletonBlock className="h-5 w-16" />
                        <SkeletonBlock className="h-5 w-20" />
                    </div>
                    <div className="flex min-h-0 flex-col gap-3">
                        {ENGAGEMENT_ROWS.map( row => (
                            <div key={row} className="flex items-center gap-3">
                                <SkeletonBlock className="size-8 shrink-0 rounded-full" />
                                <div className="min-w-0 flex-1 space-y-2">
                                    <SkeletonBlock className="h-4 w-[72%]" />
                                    <SkeletonBlock className="h-3 w-[44%]" />
                                </div>
                            </div>
                        ) )}
                    </div>
                </div>
            </div>
        </div>
    );
}
